import React, { useMemo } from 'react';
import { Modal, Tabs } from 'antd';
import { settingsModalItemsData } from '../common/tab-items/settings-modal.items';
import ModalTitle from '../common/common-componnets/ModalTitle';
import { CiSettings } from 'react-icons/ci';
import SettingsMobileDrawer from './SettingsMobileDrawer';
import { useAuth } from '../../hooks/use-auth';
import { ROLES } from '../../constants/enums/roles';

interface UserModalProps {
  openSettingsModal: boolean;
  setOpenSettingsModal: React.Dispatch<boolean>;
  isMobile?: boolean;
}

const SettingsModal = ({
  openSettingsModal,
  setOpenSettingsModal,
  isMobile = false,
}: UserModalProps) => {
  const { data: loggedInUser } = useAuth();

  const closeModal = () => {
    setOpenSettingsModal(false);
  };

  // Roles are read here rather than passed in by the caller, so the desktop and
  // mobile entry points cannot disagree on which sections a user gets.
  const filteredItems = useMemo(() => {
    const isPjesemarres = !!loggedInUser?.rolet.includes(ROLES.pjesmarres);

    return settingsModalItemsData(closeModal).filter(item => {
      if (item.key === '2') return !isPjesemarres;
      if (item.key === '3' || item.key === '4') return isPjesemarres;
      return true;
    });
  }, [loggedInUser?.rolet]);

  if (isMobile) {
    return (
      <SettingsMobileDrawer
        open={openSettingsModal}
        onClose={closeModal}
        items={filteredItems}
      />
    );
  }

  const tabItems = filteredItems.map(({ key, title, children }) => ({
    key,
    label: (
      <div className="text-base font-medium tracking-wide">
        <span style={{ color: '#003666' }}>{title}</span>
      </div>
    ),
    children,
  }));

  return (
    <Modal
      title={
        <ModalTitle
          title="Account Settings"
          icon={<CiSettings className="h-8 w-8" />}
          onClose={closeModal}
        />
      }
      closeIcon={null}
      centered
      open={openSettingsModal}
      footer={null}
      onCancel={closeModal}
      className="modalStyle flex"
      width={900}
    >
      <Tabs tabPosition="left" items={tabItems} className="mt-6" />
    </Modal>
  );
};

export default SettingsModal;
